import React from 'react'

const ResourceCard = ({ name, img }) => {
  return (
    <article className='resource'>
      <div className='resource__media'>
        <img src={img} alt={name} loading='lazy' />
      </div>
      <h3 className='resource__name'>{name}</h3>
    </article>
  )
}

export default ResourceCard
